const MESSAGING_SERVICE = 'messaging'

export const MESSAGING_SERVICE_SSE_PATH = `/${MESSAGING_SERVICE}/real-time/subscribe`
export const WEB_PROXY_SSE_PATH = '/web/api/sse-messaging/subscribe'

export const PRODUCTION_MESSAGING_SUBDOMAIN = 'sse.vinted'
export const DOT_COM_PRODUCTION_MESSAGING_SUBDOMAIN = 'sse.www.vinted'
